import { makeHttpClient, _unwrapAxiosResponse } from "./http";
import env from "@/environment/env.json";

export default class PlayGroundService {
  private httpClient = makeHttpClient();
  getPresetsList(customer: any) {
    const headers = {
      headers: {
        "Content-Type": "multipart/form-data",
        tenant: customer
      }
    };
    const url =
      `${env.whatIFAnlysisUrl}playground/preset/scenario/?customer_id=` +
      customer;
    return _unwrapAxiosResponse(
      this.httpClient.get<PlayGroundService>(url, headers)
    );
  }

  getPlaygroundList(query: any, customer: any) {
    const headers = {
      headers: {
        "Content-Type": "multipart/form-data",
        tenant: customer
      }
    };
    const url =
      `${env.whatIFAnlysisUrl}playground/create/?customer_id=` +
      customer +
      "&" +
      query;
    return _unwrapAxiosResponse(
      this.httpClient.get<PlayGroundService>(url, headers)
    );
  }

  createPlayground(form: any, customer: any) {
    const headers = {
      headers: {
        "Content-Type": "multipart/form-data",
        tenant: customer
      }
    };
    return _unwrapAxiosResponse(
      this.httpClient.post<PlayGroundService>(
        env.whatIFAnlysisUrl + "playground/create/",
        form
      )
    );
  }
}
